<template>
  <div class="base-dropdown" :class="{ 'base-dropdown--block': block }" @click="$emit('click')">
    <slot>
      <base-text light :size="size">
        {{ label }}
      </base-text>
    </slot>
    <base-icon
      v-if="showIcon"
      class="base-dropdown__icon" :class="{'base-dropdown__icon--active': active}"
      icon="chevron-down-black"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseDropdown',
  props: {
    /**
     * The label to display in the dropdown
     */
    label: {
      type: String,
      default: 'Dropdown',
    },
    /**
     * If true, the dropdown will be displayed as a block element
     */
    block: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.base-dropdown{
    display: inline-flex;
    justify-content: space-between;
    cursor: pointer;
    &__icon{
        margin-left: 7px;
    }
    &__icon--active{
        transform: rotate(180deg);
    }
    &--block{
        display: flex;
    }
}
</style>
